<script lang="ts" setup>
import YouCanDoThisCard from '../YouCanDoThis/YouCanDoThisCard.vue';

defineProps<{
  imageNumber: InstanceType<typeof YouCanDoThisCard>['$props']['imageNumber'];
}>();
</script>

<template>
  <YouCanDoThisCard :image-number="imageNumber">
    <template #titleText>
      多様な選択肢を比較検討し、<span
        :class="$style['youCanDoThisTitleText--accent']"
        >あなたに最適なプランを</span
      >
    </template>
    <template #detail>
      オカネコのアドバイザーは、住宅に関することのほか、将来かかるであろう教育資金、老後資金の必要額や備え方など、人生をトータルで考えた資金計画をご提案します。一方的な提案ではなく、一人ひとりの夢や考え方を踏まえ、一緒に最適な対策を考えていきます。利用前に不明な点や質問があれば、どんなことでも丁寧にお答えし、納得していただけるまでサポートします。それで納得がいかなければ、提案を進めなくても結構です。その場合でも料金は一切いただきませんので、ご安心ください。
    </template>
  </YouCanDoThisCard>
</template>

<style lang="scss" module>
.youCanDoThisTitleText {
  &--accent {
    color: $color-text-and-object-accent-primary;
  }
}
</style>
